"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'da-client' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams) {
                return _this.bi.log(logParams);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 82 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'da-client' });
    }
    ;
    /**
    * @typedef {Object} thumbClickCommentParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: thumb_click_comment. Evid: 105.
     * Event description: from commentable things there is an icon that will take the user direct to the comments section.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {thumbClickCommentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thumbClickComment = function (params) {
        return this.bi.log(__assign({ evid: 105 }, params));
    };
    /**
    * @typedef {Object} verifyEmailOpenEmailParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} should be 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: verify_email_open_email. Evid: 232.
     * Event description: user opened verification email.
    Should only be for DA auth process..
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} should be 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {verifyEmailOpenEmailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.verifyEmailOpenEmail = function (params) {
        return this.bi.log(__assign({ evid: 232 }, params));
    };
    /**
    * @typedef {Object} whatDywOptionOtherClickCancelParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: what_dyw_option_other_click_cancel. Evid: 224.
     * Event description: What_dyw_screen option "other' toggled and clicked "cancel".
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywOptionOtherClickCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywOptionOtherClickCancel = function (params) {
        return this.bi.log(__assign({ evid: 224 }, params));
    };
    /**
    * @typedef {Object} recoverPasswordClickParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid connected to the entered username
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: recover_password_click. Evid: 255.
     * Event description: After chosing forgot password the user can enter their username and click recover password
    If we recognize the user then add the uuid and it will go to users.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid connected to the entered username
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {recoverPasswordClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.recoverPasswordClick = function (params) {
        return this.bi.log(__assign({ evid: 255 }, params));
    };
    /**
    * @typedef {Object} whatDywOptionOtherToggleParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {boolean} new_state - new_state of the option, true if turned on, false if turned off
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: what_dyw_option_other_toggle. Evid: 222.
     * Event description: What_dyw_screen option "other' toggled.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * new_state - Type: bool. Desc: new_state of the option, true if turned on, false if turned off
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywOptionOtherToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywOptionOtherToggle = function (params) {
        return this.bi.log(__assign({ evid: 222 }, params));
    };
    /**
    * @typedef {Object} wixContactSubmitTicketFormParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {string} topic - the topic/assign group of the ticket
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Submit Ticket form. Evid: 577.
     * Event description: Clicking the "Submit a ticket" button at the bottom of the ticket form.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * topic - Type: string. Desc: the topic/assign group of the ticket
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactSubmitTicketFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactSubmitTicketForm = function (params) {
        return this.bi.log(__assign({ evid: 577 }, params));
    };
    /**
    * @typedef {Object} sortTypeSelectParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} sort_selection - the string of the sort selected: eg(whatshot/newest/popular/undiscovered)
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: sort_type_select. Evid: 122.
     * Event description: selecting from the sort drop down.  selections are whatshot/newest/popular/undiscovered.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * sort_selection - Type: string. Desc: the string of the sort selected: eg(whatshot/newest/popular/undiscovered)
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {sortTypeSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sortTypeSelect = function (params) {
        return this.bi.log(__assign({ evid: 122 }, params));
    };
    /**
    * @typedef {Object} dailyDevOpenCalendarParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: daily_dev_open_calendar. Evid: 131.
     * Event description: click the button to open a calendar for date selection.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {dailyDevOpenCalendarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dailyDevOpenCalendar = function (params) {
        return this.bi.log(__assign({ evid: 131 }, params));
    };
    /**
    * @typedef {Object} wixContactSubmitCallbackFormParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Submit Callback form. Evid: 579.
     * Event description: Clicking the "Request Callback" button at the bottom of the callback form.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactSubmitCallbackFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactSubmitCallbackForm = function (params) {
        return this.bi.log(__assign({ evid: 579 }, params));
    };
    /**
    * @typedef {Object} signupScreenClickSignupParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - V2 The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_screen_click_signup. Evid: 247.
     * Event description: On signup form, user clicks "Signup" button ("Become a Deviant" in legacy forms)..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: V2 The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupScreenClickSignupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupScreenClickSignup = function (params) {
        return this.bi.log(__assign({ evid: 247 }, params));
    };
    /**
    * @typedef {Object} recoverPasswordEmailSentShow259Params
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of user requesting username
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: recover_username_email_sent_show. Evid: 259.
     * Event description: Once the recover username has been clicked this acknowledgement is sent
    we have the user at his point so we should send the uuid.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of user requesting username
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {recoverPasswordEmailSentShow259Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.recoverPasswordEmailSentShow259 = function (params) {
        return this.bi.log(__assign({ evid: 259 }, params));
    };
    /**
    * @typedef {Object} topNavClickParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} link_name - the clickable text
    * @property {Url} link_url - The link clicked on by the user
    * @property {number} indicator - 1 indicates that there is an indicator, 0 or null indicates no indicator or not relevant
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: top_nav_click. Evid: 700.
     * Event description: User clicks on any of the links from the top nav bar.  link names: logo, browse, watch, shop, groups,forum,cart,search,inbox - logged in only, notifiations - logged in only, user - logged in only, submit , join - anon only, sign in - anon only. indicator field indicates if there was a message indicator dot above watch or anything else.  0 if not relevant.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * link_name - Type: string. Desc: the clickable text
     *
     * link_url - Type: url. Desc: The link clicked on by the user
     *
     * indicator - Type: numeric. Desc: 1 indicates that there is an indicator, 0 or null indicates no indicator or not relevant
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {topNavClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.topNavClick = function (params) {
        return this.bi.log(__assign({ evid: 700 }, params));
    };
    /**
    * @typedef {Object} signupErrorParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {string} error_message - error_msg (e.g. 'missing required field' .. )
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_error. Evid: 249.
     * Event description: Signup screen, error raised on form submission..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * error_message - Type: string. Desc: error_msg (e.g. 'missing required field' .. )
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupError = function (params) {
        return this.bi.log(__assign({ evid: 249 }, params));
    };
    /**
    * @typedef {Object} firstLoginStartByScreenShowParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: first_login_start_by_screen_show. Evid: 212.
     * Event description: first_login_start_by_screen fully rendered and interactive. This is the screen prompting for a nick and DOB as part of signup, only shown after social connect.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {firstLoginStartByScreenShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.firstLoginStartByScreenShow = function (params) {
        return this.bi.log(__assign({ evid: 212 }, params));
    };
    /**
    * @typedef {Object} clickAddToCollectionDoneParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} collectionid - id of  the chosen collection
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {number} num_collections - denotes the number of collections added to, so minimum 1 if its just the case where one collection is used, but if more we want to know how many
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: click_add_to_collection_done. Evid: 331.
     * Event description: "on eclipse - finish th process of add to collection, click done on the model (after clicking the star sign).
    on green -
    1.  chose a collection on the collection down down list (side bar, deviation page).
    2.  Add new collection on the collection down down list (side bar, deviation page) , clicking add actually finish the process.
    3.  drop a deviation on a collection (deviation page/browse/profile etc.)    [eclipse] if one collection is use we record the collectionid if multiple collectionid is null and we record the number of collections the deviation is saved to..
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * collectionid - Type: numeric. Desc: id of  the chosen collection
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * num_collections - Type: numeric. Desc: denotes the number of collections added to, so minimum 1 if its just the case where one collection is used, but if more we want to know how many
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {clickAddToCollectionDoneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickAddToCollectionDone = function (params) {
        return this.bi.log(__assign({ evid: 331 }, params));
    };
    /**
    * @typedef {Object} facetClickParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} facetitem - the clickable text
    * @property {string} facetname - the name of the facet (''facet_type,'facet_content','facet_category')
    * @property {Url} link_url - The link clicked on by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: facet_click. Evid: 390.
     * Event description: user clicks on facet/category (deviation page).
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * facetitem - Type: string. Desc: the clickable text
     *
     * facetname - Type: string. Desc: the name of the facet (''facet_type,'facet_content','facet_category')
     *
     * link_url - Type: url. Desc: The link clicked on by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {facetClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.facetClick = function (params) {
        return this.bi.log(__assign({ evid: 390 }, params));
    };
    /**
    * @typedef {Object} signupLoginModalXParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_login_modal_x. Evid: 250.
     * Event description: User closes the signup / login screen popup using the X button (upper right corner)..
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupLoginModalXParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupLoginModalX = function (params) {
        return this.bi.log(__assign({ evid: 250 }, params));
    };
    /**
    * @typedef {Object} loginErrorParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {string} error_message - error_msg (e.g. 'the user name or email does not exist', 'missing required field' .. )
    * @property {string} error_type - error_type (e.g. 'missing fields', 'security policy')
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - guid of user, only when user_name_challenge_mode is true
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_error. Evid: 203.
     * Event description: Login screen, clicked "login" button and error raised..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * error_message - Type: string. Desc: error_msg (e.g. 'the user name or email does not exist', 'missing required field' .. )
     *
     * error_type - Type: string. Desc: error_type (e.g. 'missing fields', 'security policy')
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid. Desc: guid of user, only when user_name_challenge_mode is true
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginError = function (params) {
        return this.bi.log(__assign({ evid: 203 }, params));
    };
    /**
    * @typedef {Object} watchClickParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {GUID} friendid - the guid of the user being watched.
    * @property {number} is_watching - 1 if users is currently watching the user they are viewing/clicking on 0 if they are not currently watching
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: watch_click. Evid: 380.
     * Event description: When a user clicks on watch another user.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * friendid - Type: guid. Desc: the guid of the user being watched.
     *
     * is_watching - Type: numeric. Desc: 1 if users is currently watching the user they are viewing/clicking on 0 if they are not currently watching
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {watchClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.watchClick = function (params) {
        return this.bi.log(__assign({ evid: 380 }, params));
    };
    /**
    * @typedef {Object} wixContactClickOnBannerParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {Url} banner_target_url - The button link url
    * @property {string} banner_title - banner's content title (in case changing)
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Click on Banner. Evid: 593.
     * Event description: Clicking the "Get Started" button on the banner.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * banner_target_url - Type: url. Desc: The button link url
     *
     * banner_title - Type: string. Desc: banner's content title (in case changing)
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickOnBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickOnBanner = function (params) {
        return this.bi.log(__assign({ evid: 593 }, params));
    };
    /**
    * @typedef {Object} backToClickParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {Url} link_url - the url of page the back to button direct to
    * @property {number} next_itemid - the numeric id of page the back to button direct to if exists
    * @property {number} next_typeid - the type of page the back to button direct to if exists
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: back_to_click. Evid: 304.
     * Event description: this event will be fired every time that a user/anon will click back to XXX
    the back button might direct to page (eg browse/notification etc), profile , deviation , gallery etc.
    next_typeid will reflect the type of page the back to button direct to if exists (not for pages browse/notification etc).
    next_itmid will reflect the numeric id of page the back to button direct to if exists (not for pages browse/notification etc).
    link_url will reflect the url of page the back to button direct to.
    typeid is the type of page click button is on (deviation/status/poll)..
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * link_url - Type: url. Desc: the url of page the back to button direct to
     *
     * next_itemid - Type: numeric. Desc: the numeric id of page the back to button direct to if exists
     *
     * next_typeid - Type: numeric. Desc: the type of page the back to button direct to if exists
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {backToClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.backToClick = function (params) {
        return this.bi.log(__assign({ evid: 304 }, params));
    };
    /**
    * @typedef {Object} whatDywClickSkipParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: What_dyw_click_skip. Evid: 225.
     * Event description: What_dyw_screen click_skip.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywClickSkipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywClickSkip = function (params) {
        return this.bi.log(__assign({ evid: 225 }, params));
    };
    /**
    * @typedef {Object} forgotPasswordCancelParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: forgot_password_cancel. Evid: 254.
     * Event description: After choosing forgot password the user can cancel out of this with the cancel button.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {forgotPasswordCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forgotPasswordCancel = function (params) {
        return this.bi.log(__assign({ evid: 254 }, params));
    };
    /**
    * @typedef {Object} recoverPasswordEmailSentShow256Params
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid for user requesting reset
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: recover_password_email_sent_show. Evid: 256.
     * Event description: Once the recover password has been clicked this acknowledgement is sent
    we have the user at his point so we should send the uuid.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid for user requesting reset
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {recoverPasswordEmailSentShow256Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.recoverPasswordEmailSentShow256 = function (params) {
        return this.bi.log(__assign({ evid: 256 }, params));
    };
    /**
    * @typedef {Object} backToTopParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches. mainly browse and search
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {number} offset - where the user is on the page - or how many thumbs have been loaded so far
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: back_to_top. Evid: 97.
     * Event description: When a user clicks the back to top botton on infinite scroll pages, record the offset ie where the user is on the page - or how many thumbs have been loaded so far, to be precise.  In the case of profile related pages da_item_id is the profileid.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches. mainly browse and search
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * offset - Type: numeric. Desc: where the user is on the page - or how many thumbs have been loaded so far
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {backToTopParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.backToTop = function (params) {
        return this.bi.log(__assign({ evid: 97 }, params));
    };
    /**
    * @typedef {Object} clickAddToCollectionParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: click_add_to_collection. Evid: 330.
     * Event description: on eclipse -click on the star to open the add to collection/ fave, opens modal.
    on green -
    1.  click on the down arrow that opent a drop down of collections (deviation page).
    2.  drag a deviation (deviation page/browse/profile/watch).
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {clickAddToCollectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickAddToCollection = function (params) {
        return this.bi.log(__assign({ evid: 330 }, params));
    };
    /**
    * @typedef {Object} notificationRemoveParams
    * @property {GUID} client_id - client id
    * @property {number} notificationid - the unique id of the notification
    * @property {string} notification_view - which section of notifications the user is viewing ie groups/journals/correspondenc
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {number} resource_id - the id of thing referred to in the message, eg for moderation it will be the case id
    * @property {number} resource_typeid - check qbox.deviantart.da_types
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: notification_remove. Evid: 603.
     * Event description: user removes the notification from view, by clicking an x.
    
     * client_id - Type: guid. Desc: client id
     *
     * notificationid - Type: numeric. Desc: the unique id of the notification
     *
     * notification_view - Type: string. Desc: which section of notifications the user is viewing ie groups/journals/correspondenc
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * resource_id - Type: numeric. Desc: the id of thing referred to in the message, eg for moderation it will be the case id
     *
     * resource_typeid - Type: numeric. Desc: check qbox.deviantart.da_types
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {notificationRemoveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationRemove = function (params) {
        return this.bi.log(__assign({ evid: 603 }, params));
    };
    /**
    * @typedef {Object} clickJoinParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: click_join. Evid: 241.
     * Event description: User clicked "Join" button..
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {clickJoinParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickJoin = function (params) {
        return this.bi.log(__assign({ evid: 241 }, params));
    };
    /**
    * @typedef {Object} almostDoneClickResendEmailParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} should be 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: almost_done_click_resend_email. Evid: 229.
     * Event description: almost_done_screen popup click_resend_email.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} should be 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {almostDoneClickResendEmailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.almostDoneClickResendEmail = function (params) {
        return this.bi.log(__assign({ evid: 229 }, params));
    };
    /**
    * @typedef {Object} notificationExpandParams
    * @property {GUID} client_id - client id
    * @property {number} notificationid - the unique id of the notification
    * @property {string} notification_view - which section of notifications the user is viewing ie groups/journals/correspondenc
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {number} resource_id - the id of thing referred to in the message, eg for moderation it will be the case id
    * @property {number} resource_typeid - check qbox.deviantart.da_types
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: notification_expand. Evid: 604.
     * Event description: user clicks on a notification to expand and view all the details.
    
     * client_id - Type: guid. Desc: client id
     *
     * notificationid - Type: numeric. Desc: the unique id of the notification
     *
     * notification_view - Type: string. Desc: which section of notifications the user is viewing ie groups/journals/correspondenc
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * resource_id - Type: numeric. Desc: the id of thing referred to in the message, eg for moderation it will be the case id
     *
     * resource_typeid - Type: numeric. Desc: check qbox.deviantart.da_types
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {notificationExpandParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationExpand = function (params) {
        return this.bi.log(__assign({ evid: 604 }, params));
    };
    /**
    * @typedef {Object} scrollToLoadMoreParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches. mainly browse and search
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {number} offset - where the user is on the page - or how many thumbs have been loaded so far
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: scroll_to_load_more. Evid: 98.
     * Event description: When a user scrolls to the bottom of an infinite scroll page, the page will load more images.  , record the offset ie where the user is on the page - or how many thumbs have been loaded so far, to be precise.  In the case of profile related pages da_item_id is the profileid.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches. mainly browse and search
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * offset - Type: numeric. Desc: where the user is on the page - or how many thumbs have been loaded so far
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {scrollToLoadMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.scrollToLoadMore = function (params) {
        return this.bi.log(__assign({ evid: 98 }, params));
    };
    /**
    * @typedef {Object} wixContactClickOnALinkInsideASolutionParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} link_name - the clickable text
    * @property {Url} link_url - the link's url
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Click on a Link Inside a Solution. Evid: 575.
     * Event description: User click on a link inside the solution content.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * link_name - Type: string. Desc: the clickable text
     *
     * link_url - Type: url. Desc: the link's url
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickOnALinkInsideASolutionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickOnALinkInsideASolution = function (params) {
        return this.bi.log(__assign({ evid: 575 }, params));
    };
    /**
    * @typedef {Object} firstLoginStartByScreenSubmitSuccessParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: first_login_start_by_screen_submit_success. Evid: 214.
     * Event description: first_login_start_by_screen - successfully submitted form..
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {firstLoginStartByScreenSubmitSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.firstLoginStartByScreenSubmitSuccess = function (params) {
        return this.bi.log(__assign({ evid: 214 }, params));
    };
    /**
    * @typedef {Object} firstLoginStartByScreenSubmitFailureParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {string} error_msg - error message ('the user name or email does not exist', 'missing required field' .. )
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: first_login_start_by_screen_submit_failure. Evid: 215.
     * Event description: first_login_start_by_screen - failure to submit form.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * error_msg - Type: string. Desc: error message ('the user name or email does not exist', 'missing required field' .. )
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {firstLoginStartByScreenSubmitFailureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.firstLoginStartByScreenSubmitFailure = function (params) {
        return this.bi.log(__assign({ evid: 215 }, params));
    };
    /**
    * @typedef {Object} clickPrivacyPolicyParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: click_privacy_policy. Evid: 207.
     * Event description: Login screen, user clicked privacy policy.
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {clickPrivacyPolicyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickPrivacyPolicy = function (params) {
        return this.bi.log(__assign({ evid: 207 }, params));
    };
    /**
    * @typedef {Object} viewModeSelectParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} link_name - the clickable text
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: view_mode_select. Evid: 620.
     * Event description: for feedback there is the option to switch the view between simple and advanced view.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * link_name - Type: string. Desc: the clickable text
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {viewModeSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewModeSelect = function (params) {
        return this.bi.log(__assign({ evid: 620 }, params));
    };
    /**
    * @typedef {Object} wixContactAnnouncementToggledOffParams
    * @property {string} announcement_text - the announcement that is shows to users
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Announcement Toggled Off. Evid: 586.
     * Event description: Announcement on the current issue has been toggled off.
    
     * announcement_text - Type: string. Desc: the announcement that is shows to users
     *
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactAnnouncementToggledOffParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactAnnouncementToggledOff = function (params) {
        return this.bi.log(__assign({ evid: 586 }, params));
    };
    /**
    * @typedef {Object} clickReportBackParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being reported
    * @property {string} modal_page - the page of the modal the user clicked from
    * @property {number} modal_version - The version of the reporting flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: click_report_back. Evid: 26.
     * Event description: In the new version of the report the modal has many pages with next and back buttons.  Record when a user moves back a page.
    
    Record the deviation being reported and the version of the flow as well as page the user clicked from..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being reported
     *
     * modal_page - Type: string. Desc: the page of the modal the user clicked from
     *
     * modal_version - Type: numeric. Desc: The version of the reporting flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {clickReportBackParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickReportBack = function (params) {
        return this.bi.log(__assign({ evid: 26 }, params));
    };
    /**
    * @typedef {Object} recoverUsernameClickParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of user requesting username
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: recover_username_click. Evid: 258.
     * Event description: After chosing forgot username the user can enter their email and click recover username
    If we recognize the user then add the uuid.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of user requesting username
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {recoverUsernameClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.recoverUsernameClick = function (params) {
        return this.bi.log(__assign({ evid: 258 }, params));
    };
    /**
    * @typedef {Object} loginScreenCaptchaShowParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_screen_captcha_show. Evid: 227.
     * Event description: captcha screen fully rendered and interactive..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginScreenCaptchaShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginScreenCaptchaShow = function (params) {
        return this.bi.log(__assign({ evid: 227 }, params));
    };
    /**
    * @typedef {Object} usernameClickParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: username_click. Evid: 101.
     * Event description: Many thumbs also has a username that is clickable directly to take you to the profile page of the creator of that thing.  This event records that action.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {usernameClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.usernameClick = function (params) {
        return this.bi.log(__assign({ evid: 101 }, params));
    };
    /**
    * @typedef {Object} navigationArrowClickParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} galleryid - if the item is in a gallery and the arrow shows the next item then this optional field is for the gallery name
    * @property {number} itemid - the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} direction - [next|previous] right arrow = next, left = previous
    * @property {number} next_itemid - the next item in the series, either by browse or search or in a gallery
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: navigation_arrow_click. Evid: 300.
     * Event description: right and left arrows by the deviation or other item give the next item or previous item in the series.In the case where its a gallery then galleryid is recorded.  Next item id is recorded.  direction is a string that defines which arrow is clicked left arrow is 'next' and right arrow is 'previous'.  In order to be future proof for similar functionality for commissions, status and polls, using typeid and itemid instead of just deviationid.
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * galleryid - Type: numeric. Desc: if the item is in a gallery and the arrow shows the next item then this optional field is for the gallery name
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * direction - Type: string. Desc: [next|previous] right arrow = next, left = previous
     *
     * next_itemid - Type: numeric. Desc: the next item in the series, either by browse or search or in a gallery
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {navigationArrowClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.navigationArrowClick = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    /**
    * @typedef {Object} buyCoreClickButtonParams
    * @property {GUID} client_id - client id
    * @property {number} membershiplength - length, in months, of the membership chose (0 zero when testing)
    * @property {number} membershiptypeid - subproductid of for the specific core membership type chosen
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: buy_core_click_button. Evid: 500.
     * Event description: "User clicks the buy core button on the https://www.deviantart.com/core-membership/ page
    
    same event for each button membershiptypeid will indicate which button is clicked
    ideally use item id
    
    for clarity membershiplength will be the number of months for for the membership".
    
     * client_id - Type: guid. Desc: client id
     *
     * membershiplength - Type: numeric. Desc: length, in months, of the membership chose (0 zero when testing)
     *
     * membershiptypeid - Type: numeric. Desc: subproductid of for the specific core membership type chosen
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {buyCoreClickButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.buyCoreClickButton = function (params) {
        return this.bi.log(__assign({ evid: 500 }, params));
    };
    /**
    * @typedef {Object} fullscreenModeParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} deviationid - The id of the deviation being viewed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    * @property {string} viewmode - [fullscreen|regular] - the mode that is being switched to
    **/
    /**
     * Name: fullscreen_mode. Evid: 302.
     * Event description: User clicks to go / return from full screen mode. view_mode is a string that records which view the user is going to. in this case either 'fullscreen' or 'regular'.
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * deviationid - Type: numeric. Desc: The id of the deviation being viewed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     *
     * viewmode - Type: string. Desc: [fullscreen|regular] - the mode that is being switched to
     * @param {fullscreenModeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fullscreenMode = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} chooseNewPasswordShowParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user who is changing password
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: choose_new_password_show. Evid: 261.
     * Event description: When the user requests to change the password the recieve and email, clicking the link in the email takes them to a page where they can input a new password.  This event is for when that page is shown.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user who is changing password
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {chooseNewPasswordShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.chooseNewPasswordShow = function (params) {
        return this.bi.log(__assign({ evid: 261 }, params));
    };
    /**
    * @typedef {Object} wixContactClickToContactButtonParams
    * @property {string} button_text - currently: "Click to Contact"
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - "Click to Contact" button. Evid: 595.
     * Event description: Clicking the "Click to Contact" button after the 3rd section of the contact page.
    
     * button_text - Type: string. Desc: currently: "Click to Contact"
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickToContactButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickToContactButton = function (params) {
        return this.bi.log(__assign({ evid: 595 }, params));
    };
    /**
    * @typedef {Object} signupSuccessParams
    * @property {string} auth_mode - if used external then {'google', 'facebook', 'wix'}, otherwise null
    * @property {GUID} client_id - client id
    * @property {number} deviationid - V2 : The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} referral_info - Currently Null. FFU : Trigger for form show (e.g. user clicked Join)
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_success. Evid: 248.
     * Event description: Successful submition of signup form (after creation of user id).
    Signup successfully completed, new DA user id created.
    
     * auth_mode - Type: string. Desc: if used external then {'google', 'facebook', 'wix'}, otherwise null
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: V2 : The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * referral_info - Type: string. Desc: Currently Null. FFU : Trigger for form show (e.g. user clicked Join)
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupSuccess = function (params) {
        return this.bi.log(__assign({ evid: 248 }, params));
    };
    /**
    * @typedef {Object} wixContactAnnouncementToggledOnParams
    * @property {string} announcement_text - the announcement that is shows to users
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Announcement Toggled On. Evid: 585.
     * Event description: Announcement on the current issue has been toggled on.
    
     * announcement_text - Type: string. Desc: the announcement that is shows to users
     *
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactAnnouncementToggledOnParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactAnnouncementToggledOn = function (params) {
        return this.bi.log(__assign({ evid: 585 }, params));
    };
    /**
    * @typedef {Object} clickShareParams
    * @property {GUID} client_id - client id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {number} deviationid - DEPRACATED: The deviationid of the deviation being displayed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - unique user id
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: click_share. Evid: 355.
     * Event description: User clicks on the share button to bring up the popup.
    
     * client_id - Type: guid. Desc: client id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * deviationid - Type: numeric. Desc: DEPRACATED: The deviationid of the deviation being displayed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: unique user id
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {clickShareParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickShare = function (params) {
        return this.bi.log(__assign({ evid: 355 }, params));
    };
    /**
    * @typedef {Object} wixContactTicketSubmissionSuccessClientParams
    * @property {string} announcement_text - the announcement that is shows to users
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticket_id - the ticket id
    * @property {string} ticket_url - the url of the created ticket
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {string} topic - the topic/assign group of the ticket
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Ticket Submission Success  (client). Evid: 582.
     * Event description: User was able to submit a ticket through "Wix Contact".
    
     * announcement_text - Type: string. Desc: the announcement that is shows to users
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticket_id - Type: string. Desc: the ticket id
     *
     * ticket_url - Type: string. Desc: the url of the created ticket
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * topic - Type: string. Desc: the topic/assign group of the ticket
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactTicketSubmissionSuccessClientParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactTicketSubmissionSuccessClient = function (params) {
        return this.bi.log(__assign({ evid: 582 }, params));
    };
    /**
    * @typedef {Object} loginScreenClickKeepLoggedInParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {boolean} new_state - new_state of the checkbox (e.g. if checked then new stated is true)
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_screen_click_keep_logged_in. Evid: 204.
     * Event description: Login screen, checked / unchecked "keep me logged in".
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * new_state - Type: bool. Desc: new_state of the checkbox (e.g. if checked then new stated is true)
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginScreenClickKeepLoggedInParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginScreenClickKeepLoggedIn = function (params) {
        return this.bi.log(__assign({ evid: 204 }, params));
    };
    /**
    * @typedef {Object} clickDownloadButtonParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} ispaiddownload - 1 indicates that the deviation is PCP, or paid download
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: click_download_button. Evid: 350.
     * Event description: If the download is free, nothing more.  If there is a paid option a modal will open.  record if the icon is a paid icon or not.  If paid it will pop up with a button to take the user to payment.
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * ispaiddownload - Type: numeric. Desc: 1 indicates that the deviation is PCP, or paid download
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {clickDownloadButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickDownloadButton = function (params) {
        return this.bi.log(__assign({ evid: 350 }, params));
    };
    /**
    * @typedef {Object} connectWithSuccessParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: connect_with_success. Evid: 210.
     * Event description: Login screen, connect with auth succeeded.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {connectWithSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.connectWithSuccess = function (params) {
        return this.bi.log(__assign({ evid: 210 }, params));
    };
    /**
    * @typedef {Object} notificationLinkClickParams
    * @property {GUID} client_id - client id
    * @property {Url} link_url - The link clicked on by the user
    * @property {number} notificationid - the unique id of the notification
    * @property {string} notification_view - which section of notifications the user is viewing ie groups/journals/correspondenc
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {number} resource_id - the id of thing referred to in the message, eg for moderation it will be the case id
    * @property {number} resource_typeid - check qbox.deviantart.da_types
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: notification_link_click. Evid: 602.
     * Event description: user clicks on a link in the notification
    sometimes a notification will reference a deviation or a FAQ (for example to do with moderation) this event is for any link clicked on by a user.
    
     * client_id - Type: guid. Desc: client id
     *
     * link_url - Type: url. Desc: The link clicked on by the user
     *
     * notificationid - Type: numeric. Desc: the unique id of the notification
     *
     * notification_view - Type: string. Desc: which section of notifications the user is viewing ie groups/journals/correspondenc
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * resource_id - Type: numeric. Desc: the id of thing referred to in the message, eg for moderation it will be the case id
     *
     * resource_typeid - Type: numeric. Desc: check qbox.deviantart.da_types
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {notificationLinkClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationLinkClick = function (params) {
        return this.bi.log(__assign({ evid: 602 }, params));
    };
    /**
    * @typedef {Object} welcomeScreenClickXParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {boolean} is_new_user - if it's the first login for the user then true
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: welcome_screen_click_x. Evid: 217.
     * Event description: welcome_screen click_x.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * is_new_user - Type: bool. Desc: if it's the first login for the user then true
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {welcomeScreenClickXParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.welcomeScreenClickX = function (params) {
        return this.bi.log(__assign({ evid: 217 }, params));
    };
    /**
    * @typedef {Object} expandGalleryParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: see_all_click. Evid: 106.
     * Event description: In some cases like deviation recommednations there is a view more / show all button.  That will open up the full gallery, or in the case of users  like watchers and recommended follows will open the whole list of users.  And groups too..
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {expandGalleryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.expandGallery = function (params) {
        return this.bi.log(__assign({ evid: 106 }, params));
    };
    /**
    * @typedef {Object} dailyDevDateNavParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} navigation_direction - 0 for down/left/earlier date, 1 for up/right/recentdate
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} selected_date - the string representation of the date selected for daily devs
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: daily_dev_date_nav. Evid: 130.
     * Event description: In daily deviations users can navigate left and right, navigation direction 0 for down(left), 1 for up(right).
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * navigation_direction - Type: numeric. Desc: 0 for down/left/earlier date, 1 for up/right/recentdate
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * selected_date - Type: string. Desc: the string representation of the date selected for daily devs
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {dailyDevDateNavParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dailyDevDateNav = function (params) {
        return this.bi.log(__assign({ evid: 130 }, params));
    };
    /**
    * @typedef {Object} zoomModeParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} deviationid - The id of the deviation being viewed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    * @property {string} viewmode - [zoom|regular] - the mode that is being switched to
    **/
    /**
     * Name: zoom_mode. Evid: 303.
     * Event description: User clicks the image and the image is zoomed in to.  viewmode is either zoom or regular.
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * deviationid - Type: numeric. Desc: The id of the deviation being viewed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     *
     * viewmode - Type: string. Desc: [zoom|regular] - the mode that is being switched to
     * @param {zoomModeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.zoomMode = function (params) {
        return this.bi.log(__assign({ evid: 303 }, params));
    };
    /**
    * @typedef {Object} facetControlToggleParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} facet_toggle - 1 if the facets are being shown, zero if being removed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: facet_control_toggle. Evid: 124.
     * Event description: by default the facets are not shown in browse, this open up the 3 dropdowns.  indicator value is 1 when the toggle causes the facets to be shown and 0 when they are toggled to hidden.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * facet_toggle - Type: numeric. Desc: 1 if the facets are being shown, zero if being removed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {facetControlToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.facetControlToggle = function (params) {
        return this.bi.log(__assign({ evid: 124 }, params));
    };
    /**
    * @typedef {Object} fogotUsernameCancelParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: fogot_username_cancel. Evid: 257.
     * Event description: After choosing forgot username the user can cancel out of this.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {fogotUsernameCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fogotUsernameCancel = function (params) {
        return this.bi.log(__assign({ evid: 257 }, params));
    };
    /**
    * @typedef {Object} notificationViewParams
    * @property {GUID} client_id - client id
    * @property {number} notificationid - the unique id of the notification
    * @property {string} notification_view - which section of notifications the user is viewing ie groups/journals/correspondenc
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {number} resource_id - the id of thing referred to in the message, eg for moderation it will be the case id
    * @property {number} resource_typeid - check qbox.deviantart.da_types
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: notification_view. Evid: 600.
     * Event description: notification has been viewable in the users screen, either be display from clicking to the the notification type or by scroll if its a longer list..
    
     * client_id - Type: guid. Desc: client id
     *
     * notificationid - Type: numeric. Desc: the unique id of the notification
     *
     * notification_view - Type: string. Desc: which section of notifications the user is viewing ie groups/journals/correspondenc
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * resource_id - Type: numeric. Desc: the id of thing referred to in the message, eg for moderation it will be the case id
     *
     * resource_typeid - Type: numeric. Desc: check qbox.deviantart.da_types
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {notificationViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationView = function (params) {
        return this.bi.log(__assign({ evid: 600 }, params));
    };
    /**
    * @typedef {Object} almostDoneClickChangeAddressParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} should be 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: almost_done_click_change_address. Evid: 230.
     * Event description: almost_done_screen popup click_change_address.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} should be 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {almostDoneClickChangeAddressParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.almostDoneClickChangeAddress = function (params) {
        return this.bi.log(__assign({ evid: 230 }, params));
    };
    /**
    * @typedef {Object} almostDoneScreenShowParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} should be 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: almost_done_screen_show. Evid: 228.
     * Event description: almost_done_screen popup fully rendered and interactive.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} should be 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {almostDoneScreenShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.almostDoneScreenShow = function (params) {
        return this.bi.log(__assign({ evid: 228 }, params));
    };
    /**
    * @typedef {Object} dailyDevDateSelectParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} selected_date - the string representation of the date selected for daily devs
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: daily_dev_date_select. Evid: 132.
     * Event description: In daily devations users can select a date to view the selections for that day.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * selected_date - Type: string. Desc: the string representation of the date selected for daily devs
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {dailyDevDateSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dailyDevDateSelect = function (params) {
        return this.bi.log(__assign({ evid: 132 }, params));
    };
    /**
    * @typedef {Object} wixContactClickOnMainOptionParams
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Click on Main Option. Evid: 571.
     * Event description: User clicks on a main option in "Step 1".
    
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickOnMainOptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickOnMainOption = function (params) {
        return this.bi.log(__assign({ evid: 571 }, params));
    };
    /**
    * @typedef {Object} wixContactSelectSubOptionParams
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {string} level - the level of the sub option in the sub option flow
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {boolean} solution - does the sub option has a solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Select Sub Option. Evid: 572.
     * Event description: User selects a sub option from the dropdown list in "Step 2".
    
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * level - Type: string. Desc: the level of the sub option in the sub option flow
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution - Type: bool. Desc: does the sub option has a solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactSelectSubOptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactSelectSubOption = function (params) {
        return this.bi.log(__assign({ evid: 572 }, params));
    };
    /**
    * @typedef {Object} chooseNewPasswordSubmitParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user who is changing password
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: choose_new_password_submit. Evid: 262.
     * Event description: This event is for the submit button on the change password page.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user who is changing password
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {chooseNewPasswordSubmitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.chooseNewPasswordSubmit = function (params) {
        return this.bi.log(__assign({ evid: 262 }, params));
    };
    /**
    * @typedef {Object} clickReportNextParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being reported
    * @property {string} modal_page - the page of the modal the user clicked from
    * @property {number} modal_version - The version of the reporting flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: click_report_next. Evid: 22.
     * Event description: In the new version of the report the modal has many pages with next buttons.  Record when a user moves to the next page.
    
    Record the deviation being reported and the version of the flow as well as page the user clicked from..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being reported
     *
     * modal_page - Type: string. Desc: the page of the modal the user clicked from
     *
     * modal_version - Type: numeric. Desc: The version of the reporting flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {clickReportNextParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickReportNext = function (params) {
        return this.bi.log(__assign({ evid: 22 }, params));
    };
    /**
    * @typedef {Object} signupScreenClickLoginLinkParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_screen_click_login_link. Evid: 245.
     * Event description: user switches to login from signup screen. V2 only..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupScreenClickLoginLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupScreenClickLoginLink = function (params) {
        return this.bi.log(__assign({ evid: 245 }, params));
    };
    /**
    * @typedef {Object} wixContactOpenWixContactAttemptParams
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Open "Wix Contact" - Attempt. Evid: 592.
     * Event description: User opens "Wix Contact" from desktop. The Contact form has started to load..
    
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactOpenWixContactAttemptParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactOpenWixContactAttempt = function (params) {
        return this.bi.log(__assign({ evid: 592 }, params));
    };
    /**
    * @typedef {Object} loginScreenShowParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - guid of user, only when user_name_challenge_mode is true
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_screen_show. Evid: 201.
     * Event description: Login screen loaded (fully rendered and interactive).
    Only happens for users (not anonymous) if part of a user name challenge..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid. Desc: guid of user, only when user_name_challenge_mode is true
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginScreenShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginScreenShow = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    /**
    * @typedef {Object} tagClickParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} link_url - The link clicked on by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} tag_text - The string of the tag
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: tag_click. Evid: 391.
     * Event description: user clicks on tag (deviation page).
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * link_url - Type: url. Desc: The link clicked on by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * tag_text - Type: string. Desc: The string of the tag
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {tagClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.tagClick = function (params) {
        return this.bi.log(__assign({ evid: 391 }, params));
    };
    /**
    * @typedef {Object} choseReportTypeParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being reported
    * @property {number} modal_version - The version of the reporting flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} type_chosen - The item in the list of report types chosen from the left hand side of the modal
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: chose_report_type. Evid: 21.
     * Event description: Users who click the report button for both old  version will see a list of report types on the left of the modal, clicking on one will open more info on the right of the modal
    
    Record the deviation being reported and the version of the flow as well as which item from the list is chosen..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being reported
     *
     * modal_version - Type: numeric. Desc: The version of the reporting flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * type_chosen - Type: string. Desc: The item in the list of report types chosen from the left hand side of the modal
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {choseReportTypeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.choseReportType = function (params) {
        return this.bi.log(__assign({ evid: 21 }, params));
    };
    /**
    * @typedef {Object} wixContactClickOnRequestCallbackParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Click on "Request Callback". Evid: 578.
     * Event description: Clicking the "Request Callback" button.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickOnRequestCallbackParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickOnRequestCallback = function (params) {
        return this.bi.log(__assign({ evid: 578 }, params));
    };
    /**
    * @typedef {Object} usernameHoverToOpenParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: username_hover_to_open. Evid: 107.
     * Event description: Record every hover on any username that create a pop up. sent when username is visible.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {usernameHoverToOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.usernameHoverToOpen = function (params) {
        return this.bi.log(__assign({ evid: 107 }, params));
    };
    /**
    * @typedef {Object} testClientEventParams
    * @property {GUID} client_id - null
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: test client event. Evid: 999.
    
    
     * client_id - Type: guid.
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {testClientEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.testClientEvent = function (params) {
        return this.bi.log(__assign({ evid: 999 }, params));
    };
    /**
    * @typedef {Object} thumbFaveParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: thumb_fave. Evid: 102.
     * Event description: From deviation thumbs a user can fave directly.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {thumbFaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thumbFave = function (params) {
        return this.bi.log(__assign({ evid: 102 }, params));
    };
    /**
    * @typedef {Object} clickSocialShareParams
    * @property {GUID} client_id - client id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {number} deviationid - DEPRACATED: The deviationid of the deviation being displayed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} social_share - The name of the social media site somemthing is shared to
    * @property {GUID} uuid - unique user id
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: click_social_share. Evid: 356.
     * Event description: user selects which social media they want to record.  The social_share filed is a string that represents the choice the user made.  From here an external popup gives the user the opportunity to continue the process, we cannot track that..
    
     * client_id - Type: guid. Desc: client id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * deviationid - Type: numeric. Desc: DEPRACATED: The deviationid of the deviation being displayed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * social_share - Type: string. Desc: The name of the social media site somemthing is shared to
     *
     * uuid - Type: guid. Desc: unique user id
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {clickSocialShareParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickSocialShare = function (params) {
        return this.bi.log(__assign({ evid: 356 }, params));
    };
    /**
    * @typedef {Object} wixContactSolutionViewParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Solution View. Evid: 573.
     * Event description: A solution is presented to the user in "step 3".
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactSolutionViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactSolutionView = function (params) {
        return this.bi.log(__assign({ evid: 573 }, params));
    };
    /**
    * @typedef {Object} signupScreenClickEtiquettePolicyParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_screen_click_etiquette_policy. Evid: 246.
     * Event description: On signup form, user clicks "etiquette policy". V1 only..
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupScreenClickEtiquettePolicyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupScreenClickEtiquettePolicy = function (params) {
        return this.bi.log(__assign({ evid: 246 }, params));
    };
    /**
    * @typedef {Object} facetSelectParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} facetitem - then selection from the facet
    * @property {string} facetname - the name of the facet
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: facet_select. Evid: 125.
     * Event description: When a user selects a facet from one of the menus, record both the facet (the dropdown) and the facetitem (the selection in the dropdown).
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * facetitem - Type: string. Desc: then selection from the facet
     *
     * facetname - Type: string. Desc: the name of the facet
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {facetSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.facetSelect = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} contentNavbarClickParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} link_name - the clickable text
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: content_navbar_click. Evid: 120.
     * Event description: clicks to change to different browse section.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * link_name - Type: string. Desc: the clickable text
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {contentNavbarClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contentNavbarClick = function (params) {
        return this.bi.log(__assign({ evid: 120 }, params));
    };
    /**
    * @typedef {Object} watchSectionSelectParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} is_from_navbar - 1/0 depending if the click was a heading of a section or from the navbar
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: watch_section_select. Evid: 400.
     * Event description: Click on the nav bar or section name to naviagate different watch sections.  The section name is recorded and whether it was clicked on the section or the navbar.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * is_from_navbar - Type: numeric. Desc: 1/0 depending if the click was a heading of a section or from the navbar
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {watchSectionSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.watchSectionSelect = function (params) {
        return this.bi.log(__assign({ evid: 400 }, params));
    };
    /**
    * @typedef {Object} loginScreenClickLoginParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - guid of user, only when user_name_challenge_mode is true
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_screen_click_login. Evid: 202.
     * Event description: Login screen, clicked "login" button.
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid. Desc: guid of user, only when user_name_challenge_mode is true
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginScreenClickLoginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginScreenClickLogin = function (params) {
        return this.bi.log(__assign({ evid: 202 }, params));
    };
    /**
    * @typedef {Object} firstLoginStartByScreenClickedSubmitParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: first_login_start_by_screen_clicked_submit. Evid: 213.
     * Event description: first_login_start_by_screen - clicked "let's go".
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {firstLoginStartByScreenClickedSubmitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.firstLoginStartByScreenClickedSubmit = function (params) {
        return this.bi.log(__assign({ evid: 213 }, params));
    };
    /**
    * @typedef {Object} sortMenuOpenParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: sort_menu_open. Evid: 121.
     * Event description: click to open the sort menu.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {sortMenuOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sortMenuOpen = function (params) {
        return this.bi.log(__assign({ evid: 121 }, params));
    };
    /**
    * @typedef {Object} clickButtonConnectWithParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: click_button_connect_with. Evid: 208.
     * Event description: Login screen, clicked on of the "connect with" buttons.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {clickButtonConnectWithParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickButtonConnectWith = function (params) {
        return this.bi.log(__assign({ evid: 208 }, params));
    };
    /**
    * @typedef {Object} clickTermsConditionsParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: click_terms_conditions. Evid: 206.
     * Event description: Login screen, user clicked terms conditions.
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {clickTermsConditionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickTermsConditions = function (params) {
        return this.bi.log(__assign({ evid: 206 }, params));
    };
    /**
    * @typedef {Object} wixContactClickOnSubmitTicketParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Click on "Submit Ticket". Evid: 576.
     * Event description: Clicking the "Submit Ticket" button.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickOnSubmitTicketParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickOnSubmitTicket = function (params) {
        return this.bi.log(__assign({ evid: 576 }, params));
    };
    /**
    * @typedef {Object} wixContactOpenWixContactFromMobileParams
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Open "Wix Contact" From Mobile. Evid: 583.
     * Event description: User opens "Wix Contact" from a mobile device.
    
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactOpenWixContactFromMobileParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactOpenWixContactFromMobile = function (params) {
        return this.bi.log(__assign({ evid: 583 }, params));
    };
    /**
    * @typedef {Object} connectWithFailureParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix'}
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {string} error_msg - error_msg received from auth service
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: connect_with_failure. Evid: 209.
     * Event description: Login screen, connect with auth failed.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix'}
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * error_msg - Type: string. Desc: error_msg received from auth service
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {connectWithFailureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.connectWithFailure = function (params) {
        return this.bi.log(__assign({ evid: 209 }, params));
    };
    /**
    * @typedef {Object} thumbClickParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {number} rank - The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: thumb_click. Evid: 100.
     * Event description: When a user clicks on a thumbnail for anything: : browse/search,profile,notifs,deviation recos.  For all types of thing.  Including journals, collecitons, galleries, commisions.  An event will fire.  Recording what was clicked on and where it was clicked from.  Atribution is to allow us to see which searches these deviations came from for search metrics.  In user profile it records the galleries and collections that are clicked on in the folders bar.  here the section name is 'folders', type is the type of thing gallery/collection and the itemid is the id of the gallection.  For watch section is deviations/status etc.  Creatorid is the owner of the thing being clicked on.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * rank - Type: numeric. Desc: The position of the thumbnail in the set of results in which it was contained, could also be thought of as the position on the page. The array is zero indexed, so the first rank is 0
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {thumbClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thumbClick = function (params) {
        return this.bi.log(__assign({ evid: 100 }, params));
    };
    /**
    * @typedef {Object} whatDywClickContinueParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: What_dyw_click_continue. Evid: 226.
     * Event description: What_dyw_screen clicked continue.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywClickContinueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywClickContinue = function (params) {
        return this.bi.log(__assign({ evid: 226 }, params));
    };
    /**
    * @typedef {Object} wixContactOpenWixContactSuccessParams
    * @property {string} announcement_text - the announcement that is shows to users
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} ts - time since load started, in ms
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Open "Wix Contact" - Success. Evid: 570.
     * Event description: User opens "Wix Contact" from desktop. The Contact form finished loading..
    
     * announcement_text - Type: string. Desc: the announcement that is shows to users
     *
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * ts - Type: numeric. Desc: time since load started, in ms
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactOpenWixContactSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactOpenWixContactSuccess = function (params) {
        return this.bi.log(__assign({ evid: 570 }, params));
    };
    /**
    * @typedef {Object} notificationActionClickParams
    * @property {string} action_button_type - This is a reference to the question being asked of the user.  ie do they except the autotagging or would they like to join group
    * @property {GUID} client_id - client id
    * @property {number} notificationid - the unique id of the notification
    * @property {string} notification_view - which section of notifications the user is viewing ie groups/journals/correspondenc
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {number} resource_id - the id of thing referred to in the message, eg for moderation it will be the case id
    * @property {number} resource_typeid - check qbox.deviantart.da_types
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: notification_action_click. Evid: 601.
     * Event description: user clicks on an action button in a notification.
    Notification sometimes are questions to the user to do something like join a group of accept the auto tagging of a mature deviation.
    
     * action_button_type - Type: string. Desc: This is a reference to the question being asked of the user.  ie do they except the autotagging or would they like to join group
     *
     * client_id - Type: guid. Desc: client id
     *
     * notificationid - Type: numeric. Desc: the unique id of the notification
     *
     * notification_view - Type: string. Desc: which section of notifications the user is viewing ie groups/journals/correspondenc
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * resource_id - Type: numeric. Desc: the id of thing referred to in the message, eg for moderation it will be the case id
     *
     * resource_typeid - Type: numeric. Desc: check qbox.deviantart.da_types
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {notificationActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationActionClick = function (params) {
        return this.bi.log(__assign({ evid: 601 }, params));
    };
    /**
    * @typedef {Object} wixContactCallbackFailedClientParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} reason - reason for ticket tubmission fail
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Callback Failed  (client). Evid: 581.
     * Event description: User was not able to schedule a callback.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * reason - Type: string. Desc: reason for ticket tubmission fail
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactCallbackFailedClientParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactCallbackFailedClient = function (params) {
        return this.bi.log(__assign({ evid: 581 }, params));
    };
    /**
    * @typedef {Object} topNavHoverToOpenParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} menu_name - the name of the menu that is having an action done on it, inbox (not first version), notifications, profile menu, submit
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: top_nav_hover_to_open. Evid: 701.
     * Event description: User hovers over one one:user,submit .
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * menu_name - Type: string. Desc: the name of the menu that is having an action done on it, inbox (not first version), notifications, profile menu, submit
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {topNavHoverToOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.topNavHoverToOpen = function (params) {
        return this.bi.log(__assign({ evid: 701 }, params));
    };
    /**
    * @typedef {Object} clickReportCancelParams
    * @property {string} button - ***OPTIONAL*** values: X or Cancel - tells us what the user used to cancel the report
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being reported
    * @property {string} modal_page - ***OPTIONAL*** the page of the modal the user cancelled from
    * @property {number} modal_version - The version of the reporting flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: click_report_cancel. Evid: 25.
     * Event description: Users who in the reporting process may want to cancel, if so they then could do it through a cancel button or clicking the X in the top right.  The X might be a bit tricky to instrument so it might have to be assumed.
    
    for both old and new versions
    
    Record the deviation being reported and the version of the flow as well as whether cancel button or X, and which page the user canceled from..
    
     * button - Type: string. Desc: ***OPTIONAL*** values: X or Cancel - tells us what the user used to cancel the report
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being reported
     *
     * modal_page - Type: string. Desc: ***OPTIONAL*** the page of the modal the user cancelled from
     *
     * modal_version - Type: numeric. Desc: The version of the reporting flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {clickReportCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickReportCancel = function (params) {
        return this.bi.log(__assign({ evid: 25 }, params));
    };
    /**
    * @typedef {Object} contactHelpdeskClickParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} referral_info - which part of the flow the user clicked on the link to the helpdesk forgot_u_or_p/forgot_password/forgot_username
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: contact_helpdesk_click. Evid: 253.
     * Event description: There is a link underneath the two buttons that takes the user to the help desk this event is when this link is clicked
    This also applies to the forgot password and forgot username pages
    if we know which page they are on when they click it put that in referal info ie (forgot_u_or_p/forgot_password/forgot_username).
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * referral_info - Type: string. Desc: which part of the flow the user clicked on the link to the helpdesk forgot_u_or_p/forgot_password/forgot_username
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {contactHelpdeskClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactHelpdeskClick = function (params) {
        return this.bi.log(__assign({ evid: 253 }, params));
    };
    /**
    * @typedef {Object} facetMenuOpenParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} facetname - the name of the facet
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: facet_menu_open. Evid: 123.
     * Event description: click to open a facet menu.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * facetname - Type: string. Desc: the name of the facet
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {facetMenuOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.facetMenuOpen = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} wixContactTicketSubmissionFailedClientParams
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} reason - reason for ticket tubmission fail
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {string} topic - the topic/assign group of the ticket
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Ticket Submission Failed  (client). Evid: 584.
     * Event description: User was not able to submit a ticket through "Wix Contact".
    
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * reason - Type: string. Desc: reason for ticket tubmission fail
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * topic - Type: string. Desc: the topic/assign group of the ticket
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactTicketSubmissionFailedClientParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactTicketSubmissionFailedClient = function (params) {
        return this.bi.log(__assign({ evid: 584 }, params));
    };
    /**
    * @typedef {Object} theatreModeParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} deviationid - if the item is in a gallery and the arrow shows the next item then this optional field is for the gallery name
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    * @property {string} viewmode - [theatre|regualar] the view that is being switched to
    **/
    /**
     * Name: theatre_mode. Evid: 301.
     * Event description: User clicks to go / return from theatre mode.  view_mode is a string that records which view the user is going to. in this case either 'theatre' or 'regular'.
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * deviationid - Type: numeric. Desc: if the item is in a gallery and the arrow shows the next item then this optional field is for the gallery name
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     *
     * viewmode - Type: string. Desc: [theatre|regualar] the view that is being switched to
     * @param {theatreModeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.theatreMode = function (params) {
        return this.bi.log(__assign({ evid: 301 }, params));
    };
    /**
    * @typedef {Object} forgotPasswordClickParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: forgot_password_click. Evid: 251.
     * Event description: Event 205 (login_screen_click_forgot_password) leads to a screen with two buttons one for forgot password one for forgot username
    In this case the user clicks forgot password.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {forgotPasswordClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forgotPasswordClick = function (params) {
        return this.bi.log(__assign({ evid: 251 }, params));
    };
    /**
    * @typedef {Object} wixContactClickOnTheActionButtonParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Click on the Action Button. Evid: 574.
     * Event description: User click on the action button next to the solution content.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactClickOnTheActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactClickOnTheActionButton = function (params) {
        return this.bi.log(__assign({ evid: 574 }, params));
    };
    /**
    * @typedef {Object} welcomeScreenClickChangeEmailParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {boolean} is_new_user - should always be true for this event
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: welcome_screen_click_change_email. Evid: 219.
     * Event description: welcome_screen click_change_email -
    only available for first time login.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * is_new_user - Type: bool. Desc: should always be true for this event
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {welcomeScreenClickChangeEmailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.welcomeScreenClickChangeEmail = function (params) {
        return this.bi.log(__assign({ evid: 219 }, params));
    };
    /**
    * @typedef {Object} whatDywOptionOtherClickDoneParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {string} other_desc - description entered for "other" option
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: what_dyw_option_other_click_done. Evid: 223.
     * Event description: What_dyw_screen option "other' toggled and clicked "done".
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * other_desc - Type: string. Desc: description entered for "other" option
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywOptionOtherClickDoneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywOptionOtherClickDone = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} thumbSelectLoveParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {string} widgetname - Similar to section_name but in profile the sections are called widgets so it makes things clearer
    * @property {number} love - value of love meter setting
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: thumb_select_love. Evid: 104.
     * Event description: from deviation thumbs a user can give love directly, this records that a love value was selected.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * widgetname - Type: string. Desc: Similar to section_name but in profile the sections are called widgets so it makes things clearer
     *
     * love - Type: numeric. Desc: value of love meter setting
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {thumbSelectLoveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thumbSelectLove = function (params) {
        return this.bi.log(__assign({ evid: 104 }, params));
    };
    /**
    * @typedef {Object} clickCopyParams
    * @property {GUID} client_id - client id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} itemid - the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
    * @property {number} typeid - type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {number} deviationid - DEPRACTED: The deviationid of the deviation being displayed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - unique user id
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: click_copy. Evid: 357.
     * Event description: The user choses to copy the url to the clipboard rather than directly share to social media.
    
     * client_id - Type: guid. Desc: client id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced, so userid if type is 4 and deviationid if type is 1
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced. 1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * deviationid - Type: numeric. Desc: DEPRACTED: The deviationid of the deviation being displayed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: unique user id
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {clickCopyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickCopy = function (params) {
        return this.bi.log(__assign({ evid: 357 }, params));
    };
    /**
    * @typedef {Object} almostDoneClickXParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} should be 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: almost_done_click_x. Evid: 231.
     * Event description: almost_done_screen popup click_x.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} should be 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {almostDoneClickXParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.almostDoneClickX = function (params) {
        return this.bi.log(__assign({ evid: 231 }, params));
    };
    /**
    * @typedef {Object} clickReportButtonParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being reported
    * @property {number} modal_version - ***OPTIONAL*** The version of the reporting flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: click_report_button. Evid: 20.
     * Event description: Users who click the report button for both old and new version
    
    Record the deviation being reported and the version of the flow.  The motivation for instrumenting is to improve the flow, as we start AB testing we will need to know the version of the modal.  There is a question if we will know which version the users is getting so its optional here.
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being reported
     *
     * modal_version - Type: numeric. Desc: ***OPTIONAL*** The version of the reporting flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {clickReportButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickReportButton = function (params) {
        return this.bi.log(__assign({ evid: 20 }, params));
    };
    /**
    * @typedef {Object} wixContactAnnouncementClickedParams
    * @property {string} announcement_text - the announcement that is shows to users
    * @property {GUID} client_id - null
    * @property {string} lang - answers languages
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Announcement Clicked. Evid: 587.
     * Event description: Announcement was clicked.
    
     * announcement_text - Type: string. Desc: the announcement that is shows to users
     *
     * client_id - Type: guid.
     *
     * lang - Type: string. Desc: answers languages
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactAnnouncementClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactAnnouncementClicked = function (params) {
        return this.bi.log(__assign({ evid: 587 }, params));
    };
    /**
    * @typedef {Object} profileNavBarParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {string} link_name - the clickable text
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: profile_nav_bar. Evid: 200.
     * Event description: Click on the nav bar section to navigate different profile sections. The section name is recorded when a user click on a section name.
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * link_name - Type: string. Desc: the clickable text
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {profileNavBarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.profileNavBar = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} forgotUsernameClickParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: forgot_username_click. Evid: 252.
     * Event description: Event 205 (login_screen_click_forgot_password) leads to a screen with two buttons one for forgot password one for forgot username
    In this case the user clicks forgot Username.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {forgotUsernameClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forgotUsernameClick = function (params) {
        return this.bi.log(__assign({ evid: 252 }, params));
    };
    /**
    * @typedef {Object} noAccessToEmailClickParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} referral_info - which request was shown when user clicked to the faq [password/username]
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of user who sent request
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: no_access_to_email_click. Evid: 260.
     * Event description: After clicking recover username or password then the user sees a confirmation page
    evid 256/259
    there is a link that the user should click if they do no have access the email associated with the account.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * referral_info - Type: string. Desc: which request was shown when user clicked to the faq [password/username]
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of user who sent request
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {noAccessToEmailClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.noAccessToEmailClick = function (params) {
        return this.bi.log(__assign({ evid: 260 }, params));
    };
    /**
    * @typedef {Object} clickLoginParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: click_login. Evid: 242.
     * Event description: User clicked "Login" button (not the same as "login_screen_click_login").
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {clickLoginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickLogin = function (params) {
        return this.bi.log(__assign({ evid: 242 }, params));
    };
    /**
    * @typedef {Object} signupScreenShowParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - v2 The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} referral_info - Currently Null. FFU : Trigger for form show (e.g. user clicked Join)
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: signup_screen_show. Evid: 243.
     * Event description: signup screen loaded (fully rendered), either as popup or by navigation to a page..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: v2 The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * referral_info - Type: string. Desc: Currently Null. FFU : Trigger for form show (e.g. user clicked Join)
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {signupScreenShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.signupScreenShow = function (params) {
        return this.bi.log(__assign({ evid: 243 }, params));
    };
    /**
    * @typedef {Object} welcomeScreenShowParams
    * @property {number} absent_days - days since last successful login (integer)
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {boolean} is_new_user - if it's the first login for the user then true
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: welcome_screen_show. Evid: 216.
     * Event description: welcome_screen fully rendered and interactive.
    If shown to a new user then is_new_user = true and absent_days is null
    If shown to a returning user then is_new_user = false and absent days is populated..
    
     * absent_days - Type: numeric. Desc: days since last successful login (integer)
     *
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * is_new_user - Type: bool. Desc: if it's the first login for the user then true
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {welcomeScreenShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.welcomeScreenShow = function (params) {
        return this.bi.log(__assign({ evid: 216 }, params));
    };
    /**
    * @typedef {Object} buyClickParams
    * @property {GUID} client_id - client_id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} deviationid - The id of the deviation to be purchased
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - user unique guid
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: buy_click. Evid: 360.
     * Event description: User clicks on the button to buy a print.  Takes the user to a green shop page..
    
     * client_id - Type: guid. Desc: client_id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * deviationid - Type: numeric. Desc: The id of the deviation to be purchased
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: user unique guid
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {buyClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.buyClick = function (params) {
        return this.bi.log(__assign({ evid: 360 }, params));
    };
    /**
    * @typedef {Object} wixContactCallbackSuccessParams
    * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
    * @property {string} announcement_text - the announcement that is shows to users
    * @property {string} call_center_status - is the call center available for calls, closed, etc.
    * @property {GUID} callid - the call id
    * @property {number} clid - wcc call guid
    * @property {GUID} client_id - null
    * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
    * @property {string} lang - answers languages
    * @property {string} main_option_id - the id of the selected main option
    * @property {string} main_option_name - the name of the selected main option
    * @property {string} provider - the back-end that serves the contact option - wcc\answers
    * @property {string} referral_name - referral
    * @property {Url} referral_url - referral
    * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
    * @property {string} solution_title - the title of the presented solution
    * @property {string} sub_option_id - the id of the final sub option
    * @property {string} sub_option_name - the name of the final sub option
    * @property {string} ticket_id - the ticket id
    * @property {string} ticketing_status - is the option to submit a ticket is available
    * @property {GUID} uuid - null
    * @property {string} version - null
    **/
    /**
     * Name: Wix Contact - Callback Success. Evid: 580.
     * Event description: User was able to schedule a callback.
    
     * action_url - Type: url. Desc: the url of the suggested action button, next to the solution contetnt
     *
     * announcement_text - Type: string. Desc: the announcement that is shows to users
     *
     * call_center_status - Type: string. Desc: is the call center available for calls, closed, etc.
     *
     * callid - Type: guid. Desc: the call id
     *
     * clid - Type: numeric. Desc: wcc call guid
     *
     * client_id - Type: guid.
     *
     * estimated_wait_time - Type: numeric. Desc: in minutes, the estimated callback wait time presented to the user
     *
     * lang - Type: string. Desc: answers languages
     *
     * main_option_id - Type: string. Desc: the id of the selected main option
     *
     * main_option_name - Type: string. Desc: the name of the selected main option
     *
     * provider - Type: string. Desc: the back-end that serves the contact option - wcc\answers
     *
     * referral_name - Type: string. Desc: referral
     *
     * referral_url - Type: url. Desc: referral
     *
     * solution_time - Type: numeric. Desc: in minutes, the estimated time presented to the user to solve the issue by themselves
     *
     * solution_title - Type: string. Desc: the title of the presented solution
     *
     * sub_option_id - Type: string. Desc: the id of the final sub option
     *
     * sub_option_name - Type: string. Desc: the name of the final sub option
     *
     * ticket_id - Type: string. Desc: the ticket id
     *
     * ticketing_status - Type: string. Desc: is the option to submit a ticket is available
     *
     * uuid - Type: guid.
     *
     * version - Type: string.
     * @param {wixContactCallbackSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixContactCallbackSuccess = function (params) {
        return this.bi.log(__assign({ evid: 580 }, params));
    };
    /**
    * @typedef {Object} loginScreenClickForgotPasswordParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {boolean} user_name_challenge_mode - if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_screen_click_forgot_password. Evid: 205.
     * Event description: Login screen, user clicked forgot password.
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * user_name_challenge_mode - Type: bool. Desc: if the screen is shown as part of the user name challenge flow, then 1 (true), otherwise 0 (false)
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginScreenClickForgotPasswordParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginScreenClickForgotPassword = function (params) {
        return this.bi.log(__assign({ evid: 205 }, params));
    };
    /**
    * @typedef {Object} whatDywScreenShowParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: What_dyw_screen_show. Evid: 220.
     * Event description: What_dyw_screen_show.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywScreenShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywScreenShow = function (params) {
        return this.bi.log(__assign({ evid: 220 }, params));
    };
    /**
    * @typedef {Object} downloadNowClickParams
    * @property {GUID} client_id - client id
    * @property {string} component - more info about the type of page view - should be optional
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - unique user id
    * @property {string} version - version of the platform
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: download_now_click. Evid: 351.
     * Event description: clicking the download button, will open the purchase flow.
    
     * client_id - Type: guid. Desc: client id
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: unique user id
     *
     * version - Type: string. Desc: version of the platform
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {downloadNowClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.downloadNowClick = function (params) {
        return this.bi.log(__assign({ evid: 351 }, params));
    };
    /**
    * @typedef {Object} loginScreenClickSignupLinkParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_screen_click_signup_link. Evid: 244.
     * Event description: user switches to signup from login screen..
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginScreenClickSignupLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginScreenClickSignupLink = function (params) {
        return this.bi.log(__assign({ evid: 244 }, params));
    };
    /**
    * @typedef {Object} welcomeScreenClickStartParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {boolean} is_new_user - if it's the first login for the user then true
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: welcome_screen_click_start. Evid: 218.
     * Event description: welcome_screen click_start.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * is_new_user - Type: bool. Desc: if it's the first login for the user then true
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {welcomeScreenClickStartParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.welcomeScreenClickStart = function (params) {
        return this.bi.log(__assign({ evid: 218 }, params));
    };
    /**
    * @typedef {Object} thumbClickLoveMeterParams
    * @property {string} attribution - A string that allows for tracking of search results, so we can match clicks from specific searches.
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {GUID} creatorid - The guid of the owner of the thing being clicked on.
    * @property {number} itemid - the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
    * @property {number} sectionid - When the section is a known da type this is the id to reference the item in that type
    * @property {string} sectionname - The name of the section that the clicked thing is in
    * @property {number} section_typeid - In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
    * @property {number} typeid - type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: thumb_click_love_meter. Evid: 103.
     * Event description: from deviation thumbs a user can give love directly, this indicates that the lovemeter has been clicked.
    
     * attribution - Type: string. Desc: A string that allows for tracking of search results, so we can match clicks from specific searches.
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * creatorid - Type: guid. Desc: The guid of the owner of the thing being clicked on.
     *
     * itemid - Type: numeric. Desc: the numeric id of the thing being clicked or referenced,  so userid if type is 4 and deviationid if type is 1
     *
     * sectionid - Type: numeric. Desc: When the section is a known da type this is the id to reference the item in that type
     *
     * sectionname - Type: string. Desc: The name of the section that the clicked thing is in
     *
     * section_typeid - Type: numeric. Desc: In some cases sections are galleries or collections so if a item appears in a section that is a collection then the typeid is for collection - 20
     *
     * typeid - Type: numeric. Desc: type of thing being clicked on or referenced.  1 - deviation, 4- profile see check qbox.deviantart.da_types
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {thumbClickLoveMeterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thumbClickLoveMeter = function (params) {
        return this.bi.log(__assign({ evid: 103 }, params));
    };
    /**
    * @typedef {Object} closeBannerAdParams
    * @property {GUID} campaignid - The id for the campaign or specific banner
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {GUID} realestateid - The id for the location of the ad
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: close_banner_ad. Evid: 8005.
     * Event description: For the new 'el-nino' type banners there will be a button to close it.  In order to keep track of what people have closed we use this event..
    
     * campaignid - Type: guid. Desc: The id for the campaign or specific banner
     *
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * realestateid - Type: guid. Desc: The id for the location of the ad
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {closeBannerAdParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.closeBannerAd = function (params) {
        return this.bi.log(__assign({ evid: 8005 }, params));
    };
    /**
    * @typedef {Object} whatDywOptionToggleParams
    * @property {string} auth_mode - {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {boolean} new_state - new_state of the option, true if turned on, false if turned off
    * @property {string} option - the title of the option that was toggled (e.g. 'Discover Art')
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: what_dyw_option_toggle. Evid: 221.
     * Event description: What_dyw_screen option_toggle.
    
     * auth_mode - Type: string. Desc: {'google', 'facebook', 'wix', 'DA'} - if connected not via external auth then 'DA'
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * new_state - Type: bool. Desc: new_state of the option, true if turned on, false if turned off
     *
     * option - Type: string. Desc: the title of the option that was toggled (e.g. 'Discover Art')
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {whatDywOptionToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.whatDywOptionToggle = function (params) {
        return this.bi.log(__assign({ evid: 221 }, params));
    };
    /**
    * @typedef {Object} topNavMenuClickParams
    * @property {GUID} client_id - guid of the client, to recognize anons using the same system
    * @property {string} component - more info about the type of page view - should be optional
    * @property {Url} link_url - url of the link in the menu
    * @property {string} menu_item - The name/text identifier of the item being clicked in the open navbar menu. eg deviation in submit menu, or setting in profile menu (including toggles) - but not for notif menu
    * @property {string} menu_name - the name of the menu that is having an action done on it, inbox (not first version), notifications, profile menu, submit
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {string} toggle_value - string value of the state of the toggle ie view_mature, dark_theme/light_them
    * @property {GUID} uuid - the guid of the logged in user
    * @property {string} version - version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
    * @property {string} view - type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
    **/
    /**
     * Name: top_nav_menu_click. Evid: 702.
     * Event description: Users clicks a link in one of the menus:inbox (not current version),notifications, user profile, submit - this one can be anon as well.  Toggle value records the new value of the setting where available.  Toggle is a string value (dark/light, view_mature/hide_mature) or null if not relevant..
    
     * client_id - Type: guid. Desc: guid of the client, to recognize anons using the same system
     *
     * component - Type: string. Desc: more info about the type of page view - should be optional
     *
     * link_url - Type: url. Desc: url of the link in the menu
     *
     * menu_item - Type: string. Desc: The name/text identifier of the item being clicked in the open navbar menu. eg deviation in submit menu, or setting in profile menu (including toggles) - but not for notif menu
     *
     * menu_name - Type: string. Desc: the name of the menu that is having an action done on it, inbox (not first version), notifications, profile menu, submit
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * toggle_value - Type: string. Desc: string value of the state of the toggle ie view_mature, dark_theme/light_them
     *
     * uuid - Type: guid. Desc: the guid of the logged in user
     *
     * version - Type: string. Desc: version of the screen eg 'eclipse;major' for full version or 'eclipse;minor' for just navbar or minor changes
     *
     * view - Type: string. Desc: type of page being viewed: login
    tag
    submit
    browse
    art
    notes
    morelikethis
    status
    profile
    cliqz.com/tracking
    watch
    logout
    join
    today
    gallery
    prints
    favourites
    journal
    notifications
    other
     * @param {topNavMenuClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.topNavMenuClick = function (params) {
        return this.bi.log(__assign({ evid: 702 }, params));
    };
    /**
    * @typedef {Object} clickReportSubmitParams
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being reported
    * @property {number} modal_version - The version of the reporting flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} report_type - the type of report being submitted, string as it might not correlate with the typeid
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - guid of user
    * @property {string} version - null
    **/
    /**
     * Name: click_report_submit. Evid: 29.
     * Event description: In the both the old and the new versions we record with the report is submitted by the user.
    
    Record the deviation being reported and the version of the flow as well as the type of the report that is sent.
    
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being reported
     *
     * modal_version - Type: numeric. Desc: The version of the reporting flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * report_type - Type: string. Desc: the type of report being submitted, string as it might not correlate with the typeid
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: guid of user
     *
     * version - Type: string.
     * @param {clickReportSubmitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickReportSubmit = function (params) {
        return this.bi.log(__assign({ evid: 29 }, params));
    };
    /**
    * @typedef {Object} incorrectUsernameErrorShowParams
    * @property {GUID} client_id - client id
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - null
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: incorrect_username_error_show. Evid: 263.
     * Event description: In the case of forgot password, if their username does not match a valid username in the DB we will show an error.
    
     * client_id - Type: guid. Desc: client id
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid.
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {incorrectUsernameErrorShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.incorrectUsernameErrorShow = function (params) {
        return this.bi.log(__assign({ evid: 263 }, params));
    };
    /**
    * @typedef {Object} loginSuccessParams
    * @property {string} auth_mode - if used external then {'google', 'facebook', 'wix'}, otherwise null
    * @property {GUID} client_id - client id
    * @property {number} deviationid - The deviationid of the deviation being displayed
    * @property {boolean} is_new_user - if signup for new user then true, else (login for existing user) false
    * @property {number} modal_version - The version of the sisu flow that will be seen by the user
    * @property {Url} url - url of the page view
    * @property {string} platform - desktop or mobile
    * @property {Url} referer - url that the view comes from
    * @property {string} requestid - requestid is shared between all the events originating from the same request
    * @property {GUID} uuid - uuid of the user
    * @property {string} version - version of the screen / component (e.g. 1.0.11b)
    **/
    /**
     * Name: login_success. Evid: 211.
     * Event description: users successfully logged in (successful completion of Log In form. is_new_user = false (ALWAYS)..
    
     * auth_mode - Type: string. Desc: if used external then {'google', 'facebook', 'wix'}, otherwise null
     *
     * client_id - Type: guid. Desc: client id
     *
     * deviationid - Type: numeric. Desc: The deviationid of the deviation being displayed
     *
     * is_new_user - Type: bool. Desc: if signup for new user then true, else (login for existing user) false
     *
     * modal_version - Type: numeric. Desc: The version of the sisu flow that will be seen by the user
     *
     * url - Type: url. Desc: url of the page view
     *
     * platform - Type: string. Desc: desktop or mobile
     *
     * referer - Type: url. Desc: url that the view comes from
     *
     * requestid - Type: string. Desc: requestid is shared between all the events originating from the same request
     *
     * uuid - Type: guid. Desc: uuid of the user
     *
     * version - Type: string. Desc: version of the screen / component (e.g. 1.0.11b)
     * @param {loginSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loginSuccess = function (params) {
        return this.bi.log(__assign({ evid: 211 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map